// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
// import clipper from '../static/js/clipper.js'
import { InfiniteScroll } from 'mint-ui'; //列表无限滚动指令
import 'mint-ui/lib/style.css';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import { Spinner, Swipe, SwipeItem } from 'mint-ui';
import md5 from 'js-md5';
Vue.component(Swipe.name, Swipe);
Vue.component(SwipeItem.name, SwipeItem);
Vue.component(Spinner.name, Spinner);
Vue.prototype.$md5 = md5;
// import VConsole from 'vconsole'
// const vConsole = new VConsole()
// console.log(vConsole.version)

import './config/global';
import wx from 'weixin-js-sdk';

Vue.use(InfiniteScroll);
Vue.use(VueAwesomeSwiper);

// Vue.use(clipper);

Vue.config.productionTip = false;
/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js